import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import TopNavbar from "../../CommonComponent/topNavbar/TopNavbar";
import Sidebar from "../../CommonComponent/sidebar/Sidebar";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import * as icons from "react-bootstrap-icons";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import {
  AuctionDelete,
  AuctionPlayPause,
  AuctionGetAllData,
} from "../../redux/auth-reducer/auth-service";
import { Footer } from "../../Footer";
import { ModalBox } from "../Outer/Modal";
import { toast } from "react-toastify";
import { ImageUrl } from "../../utils/config/config";
import { readApiMessage } from "../../utils/helper/helper";
import { describeClosedUnopened } from "../../utils/helper/auctionFit";
import dayjs from "dayjs";
import { useHubEvent } from "../../hooks/useHubEvent";
import { useHubResync } from "../../hooks/useHubResync";
import { useSearchedPagedList } from "../../hooks/useSearchedPagedList";
import { deriveAuctionStatus } from "../../utils/helper/auctionGrid";
import { UpdateAuctionModal } from "./UpdateAuctionModal";
import { ConfirmDeleteModal } from "./ConfirmDeleteModal";
import {
  AuctionWinningsModal,
  useAuctionWinnings,
} from "../../CommonComponent/AuctionWinningsModal";
import { bidTimeLabel, teamsFromRow } from "../../utils/helper/auctionForm";
import '../../../src/index.css'

/**
 * #191: how long a push the list cannot read (see the ReceiveBidStatus handler) waits before the
 * page is asked for again - long enough to take the rest of the Worker's pass in one request.
 */
const STATUS_REFETCH_DELAY_MS = 1000;

/**
 * The status each "Sort By Status" option shows, as the server's Status parameter; "" (ALL) shows
 * every row.
 */
const STATUS_FILTERS = { live: "Live", upcoming: "Upcoming", closed: "Closed", Paused: "Paused" };

export const Auction = () => {
  const [data, setData] = useState();
  const [deleteRow, setDeleteRow] = useState(null);
  const [showEdit, setShowEdit] = useState();
  // The row the Update Auction modal edits, and a key that changes with every opening.
  const [editing, setEditing] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [pause, setPause] = useState(false);
  const [playStatus, setPlayStatus] = useState({});
  const [showView, setShowView] = useState(false);
  const [viewedAuction, setViewedAuction] = useState(null);
  const winnings = useAuctionWinnings();

  // FE-16 (#4): the search and the status filter are the server's, so they cover every page. The
  // search went in its own request without the page or the page size, any later page change, push
  // or save reloaded the list without it, and the status filtered only the page already loaded -
  // so on page 2 a status whose auctions were on page 1 showed an empty table. A new status is a
  // new fetcher, which useSearchedPagedList answers from page 1 with one request, as it does a new
  // search; the page size changes with one request for page 1 too.
  const fetchAuctions = useCallback(
    (query) => AuctionGetAllData({ ...query, Status: STATUS_FILTERS[selectedOption] }),
    [selectedOption]
  );
  const {
    rows,
    page,
    perPage,
    totalPages,
    pageSizes,
    nextPage,
    previousPage,
    changePerPage,
    reload,
    updateRows,
    searchText,
    setSearchText,
    clearSearch,
  } = useSearchedPagedList(fetchAuctions);

  function sidebarfun() {
    setData(!data);
  }

  const isUser = JSON.parse(localStorage.getItem("isUser"));

  const columns = [
    {
      name: <strong>Id</strong>,
      selector: (row, index) => index + 1,
    },

    {
      name: <strong>Auction Name</strong>,
      selector: (row) => row?.auctionName,
      sortable: true,
      width: "200px",
    },

    {
      name: <strong>Auction Image</strong>,
      selector: (row) =>
        {
          return !row?.auctionImage ? (
            <img src="../image/auction.png" className="m-2" width={50} />
          ) : (
            <img
              src={`${ImageUrl}${row.auctionImage}`}
              className="m-2"
              width={50}
            />
          );
        },
    },

    {
      name: <strong>Contest Name</strong>,
      selector: (row) => row?.tournamentName,
      sortable: true,
      width: "150px",
    },
    {
      name: <strong>Sport Name</strong>,
      // #305: the row's own sportName (usp_GetAllAuctionData). Looking it up in a separate sports
      // list gave an array, which sorted by the sport's place in that list rather than by name.
      selector: (row) => row?.sportName,
      sortable: true,
      width: "150px",
    },

    {
      name: <strong>Start Date & Time</strong>,
      selector: (row) => {
        if (!row?.startDate) return <p>Invalid date</p>;
        return (
          <p>{dayjs(row?.startDate + "Z").format("MM/DD/YYYY hh:mm:ss A")}</p>
        );
      },
      width: "200px",
    },

    {
      name: <strong>Bid Time Limit</strong>,
      selector: (row) => row?.bidTime,
      format: (row) => bidTimeLabel(row?.bidTime),
      sortable: true,
    },
    {
      name: <strong>Secondary Market</strong>,
      width: "200px",
      selector: (row) =>
        row?.secondaryMarket == true ? (
          <div className="bg-succ">Available</div>
        ) : (
          <div className="bg-dang">Unavailable</div>
        ),
      sortable: true,
      sortFunction: (a, b) => {
        const statusA = a.secondaryMarket ? "Available" : "Unavailable";
        const statusB = b.secondaryMarket ? "Available" : "Unavailable";
        return statusA.localeCompare(statusB);
      },
    },
    {
      name: <strong>Team</strong>,
      selector: (row) => (
        <>
          <button
            type="button"
            className="btn btn-primary viewButton"
            onClick={() => viewFn(row)}
          >
            {" "}
            <icons.Eye /> Team
          </button>
        </>
      ),
      width: "150px",
    },

    // PlaceBit details
    {
      name: <strong>Auction Winnings</strong>,
      selector: (row) => (
        <>
          <button
            type="button"
            className="btn btn-primary viewButton"
            onClick={() => winnings.open(row.auctionId)}
          >
            {" "}
            <icons.Eye /> 
          </button>
        </>
      ),
      width: "150px",
    },
    {
      name: <strong>Bid Status</strong>,
      // #171: with a note for the lots that bidding closed - 15 minutes before the contest - before
      // they ever opened, unsold. The list used to say nothing about them.
      wrap: true,
      selector: (row) => {
        const closedUnopened = describeClosedUnopened(row?.lotsClosedUnopened);
        return (
          <>
            {row?.status === "Upcoming" ? (
              <span style={{ color: "#f9c114" }}>Upcoming</span>
            ) : row.status === "Live" ? (
              <span style={{ color: "#043bc7" }}>Live</span>
            ) : row.status === "Paused" ? (
              <span style={{ color: "red" }}>Paused</span>
            ) : (
              <span style={{ color: "red" }}>Closed</span>
            )}
            {closedUnopened && <div className="text-danger small">{closedUnopened}</div>}
          </>
        );
      },
    },
    {
      name: <strong>Action</strong>,
      width: "200px",
      selector: (row) => (
        <>
          {row?.createdBy === isUser?.userId ? (
            <button
              type="button"
              className="text-danger btn-aucion"
              onClick={() => deleteFn(row)}
            >
              <icons.Trash />
            </button>
          ) : (
            <button
              type="button"
              disabled
              className="text-danger btn-aucion"
              onClick={() => deleteFn(row)}
            >
              <icons.Trash />
            </button>
          )}

          {row?.createdBy === isUser?.userId ? (
            <button
              type="button"
              className="text-success btn-aucion"
              onClick={() => editFn(row)}
              disabled={row.status !== "Upcoming"}
            >
              <icons.PencilSquare />
            </button>
          ) : (
            <button
              type="button"
              disabled
              className="text-success btn-aucion"
              onClick={() => editFn(row)}
            >
              <icons.PencilSquare />
            </button>
          )}

          {row.status === "Paused" ? (
            <button
              type="button"
              className="text-success btn-aucion"
              onClick={() => playPausefN(row)}
            >
              <icons.Play style={{ border: "2px solid" }} />
            </button>
          ) : (
            <button
              type="button"
              className="text-success btn-aucion"
              onClick={() => playPausefN(row)}
            >
              <icons.Pause style={{ border: "2px solid" }} />
            </button>
          )}
        </>
      ),
    },
  ];

  const viewFn = (viewItem) => {
    setShowView(true);
    setViewedAuction(viewItem);
  };

  const updatePlayStatus = (auctionId, status) => {
    setPlayStatus((prevStatus) => ({
      ...prevStatus,
      [auctionId]: status,
    }));
    setPause(!pause);
  };

  const playPausefN = (row) => {
    const statusSend = row.status != "Paused" ? true : false;
    updatePlayStatus(row.auctionId, !playStatus[row.auctionId]);
    const AuctionPlayPauseStatus = async () => {
      await AuctionPlayPause(row.auctionId, statusSend).then((response) => {
        if (response?.data?.status === true) {
          const playPaused = (list) =>
            Array.isArray(list)
              ? list.map((e) => {
                  if (e.auctionId == row.auctionId) {
                    return {
                      ...e,
                      status: row.status == "Paused" ? "Live" : "Paused",
                    };
                  } else {
                    return e;
                  }
                })
              : list;
          // #191: into the list itself, which the status filter is derived from - so the next change
          // to it (a push, a search) cannot bring the old status back.
          updateRows(playPaused);
          toast.success(response?.data?.message);
        } else {
          toast.error(response?.data?.message);
        }
      });
    };
    AuctionPlayPauseStatus();
  };

  // Each opening gets a new key, so the form starts from the row again rather than from what was
  // typed and cancelled the last time; the row stays after a close, for the modal's fade-out.
  const editFn = (row) => {
    setEditing((previous) => ({ row, key: (previous?.key ?? 0) + 1 }));
    setShowEdit(true);
  };

  const handleEditSaved = () => {
    setShowEdit(false);
    reload();
  };

  // #307: the whole row, so the confirmation can name the auction.
  const deleteFn = (row) => {
    setShowDeleteModal(true);
    setDeleteRow(row);
  };
  const handleClosed = () => {
    setShowDeleteModal(false);
    setShowEdit(false);
    setShowView(false);
  };

  const handelDelete = async () => {
    await AuctionDelete(deleteRow?.auctionId).then((res) => {
      if (res?.status == true) {
        reload();
        toast.success(res?.message);

        setShowDeleteModal(!showDeleteModal);
      } else {
        toast.error(readApiMessage(res));
      }
    });
  };

  // #182: statuses pushed while the live connection was down are lost; reload the page - with the
  // search and the status still applied.
  useHubResync(() => reload());

  // The typed text, sent once typing stops (useSearchedPagedList).
  const handleSearch = (e) => {
    const value = e.target.value;
    if (value.length === 1 && value === " ") {
      return; // Ignore the input if it's just a space
    }
    setSearchText(value);
  };

  const handleChangeOption = (event) => {
    setSelectedOption(event.target.value);
  };

  // The server has already applied "Sort By Status" (fetchAuctions); this only keeps it true while
  // the page is on screen, since a push or a pause can move a row to another status before the next
  // reload. Derived from the rows themselves: three effects used to keep them in state, and the
  // status one ran before the one that rebuilt the per-status lists, so it filtered the previous
  // list.
  const filteredData = useMemo(() => {
    if (!Array.isArray(rows)) return [];
    const status = STATUS_FILTERS[selectedOption];
    return status ? rows.filter((item) => item?.status === status) : rows;
  }, [rows, selectedOption]);

  const statusRefetchRef = useRef(null);

  useEffect(() => {
    const statusRefetch = statusRefetchRef;
    return () => clearTimeout(statusRefetch.current);
  }, []);

  // The Worker's push of every unfinished team (and of a team it has just closed), and the
  // play/pause broadcast. #191: the push carries teams, so each auction's status is derived from
  // all of its rows at once (deriveAuctionStatus) and written only when it differs, only for the
  // auctions on this page. This used to promote an auction to Live for any live row, never showed
  // a pause or a close, and started a ten-second interval per single-row auction on every push -
  // each of them reloading the page when it ran out.
  useHubEvent("ReceiveBidStatus", (data) => {
    if (!Array.isArray(data)) return;

    const rowsByAuction = new Map();
    data.forEach((row) => {
      const teamRows = rowsByAuction.get(row?.auctionId) || [];
      teamRows.push(row);
      rowsByAuction.set(row?.auctionId, teamRows);
    });
    const derived = new Map(
      [...rowsByAuction].map(([auctionId, teamRows]) => [auctionId, deriveAuctionStatus(teamRows)])
    );

    updateRows((prev) => {
      if (!Array.isArray(prev)) return prev;
      let changed = false;
      const next = prev.map((item) => {
        const status = derived.get(item.auctionId);
        if (!status || status === item.status) return item;
        changed = true;
        return { ...item, status };
      });
      return changed ? next : prev;
    });

    // A mix the push cannot read - a team just closed and none live, or all closed - for an auction
    // shown Live or Paused means it may have ended: ask the server, once for the whole pass.
    const shown = Array.isArray(rows) ? rows : [];
    const unreadable = shown.some(
      (item) =>
        derived.has(item.auctionId) &&
        derived.get(item.auctionId) === null &&
        (item.status === "Live" || item.status === "Paused")
    );
    if (unreadable && !statusRefetchRef.current) {
      statusRefetchRef.current = setTimeout(() => {
        statusRefetchRef.current = null;
        // The page as it is when the timer runs, its search and status included: reload asks
        // usePagedList for its current query.
        reload();
      }, STATUS_REFETCH_DELAY_MS);
    }
  });

  // #192 reopen: listed by name, each with its logo if it has one. The table used to need the logo
  // list as well, and an auction whose one team has no logo sends it empty, so the team was hidden.
  const viewedTeams = teamsFromRow(viewedAuction);

  return (
    <>
      <ModalBox
        show={showView}
        title={
          <>
            <h1 className="heading-dash">View Team</h1>
          </>
        }
        body={
          <>
            <Table bordered>
              <thead>
                <tr>
                  <th
                    className="bg-gray-view"
                    style={{
                      padding: "10px",
                      border: "1px solid #ccc",
                      textAlign: "center",
                    }}
                  >
                    Logo
                  </th>
                  <th
                    className="bg-gray-view"
                    style={{
                      padding: "10px",
                      border: "1px solid #ccc",
                      textAlign: "center",
                    }}
                  >
                    Team Name
                  </th>
                </tr>
              </thead>

              <tbody>
                {viewedTeams.length > 0 ? (
                  viewedTeams.map((team, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          padding: "10px",
                          border: "1px solid #ccc",
                          textAlign: "center",
                        }}
                      >
                        {team.image ? (
                          <img
                            src={ImageUrl + team.image}
                            alt={team.name}
                            style={{ width: "50px", height: "50px" }}
                          />
                        ) : (
                          "No image available"
                        )}
                      </td>
                      <td
                        style={{
                          padding: "10px",
                          border: "1px solid #ccc",
                          textAlign: "center",
                        }}
                      >
                        {team.name}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2">No teams available</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </>
        }
        footer={
          <>
            <Button variant="secondary" onClick={handleClosed}>
              Close
            </Button>
          </>
        }
      />

      <AuctionWinningsModal {...winnings.modalProps} />

      {editing && (
        <UpdateAuctionModal
          key={editing.key}
          auction={editing.row}
          show={showEdit}
          onClose={handleClosed}
          onSaved={handleEditSaved}
        />
      )}

      <ConfirmDeleteModal
        show={showDeleteModal}
        entity="auction"
        name={deleteRow?.auctionName}
        onConfirm={handelDelete}
        onCancel={handleClosed}
      />

      <TopNavbar sidebarfun={sidebarfun} />
      <div className="dasboard-group">
        <Sidebar data={data} />
        <div
          className={
            data ? "dashboard-content full-contnet" : "dashboard-content"
          }
        >
          <Row>
            <Col md={6}>
              <h1 className="heading-dash">Auction</h1>
            </Col>
            <Col md={6} className="text-right">
              <Link to="/SuperAdmin/CreateAuction">
                {" "}
                <Button className="primary button-create-auction">
                  {" "}
                  <icons.Plus class="icon-plus" /> Create New Auction
                </Button>
              </Link>
            </Col>
          </Row>

          <div className="group_data_table auction-list">
            <div class="auction-manager search-input filter d-flex align-items-center">
              <label className="sort-status">Sort By Status</label>

              <Form.Select
                name="select"
                value={selectedOption}
                onChange={handleChangeOption}
                className="me-4"
                required
                as="select"
              >
                <option value={""}>ALL</option>
                <option value={"live"}>Live</option>
                <option value={"upcoming"}>Upcoming</option>
                <option value={"closed"}>Closed</option>
                <option value={"Paused"}>Paused</option>
              </Form.Select>

              <input
                type="text"
                className="form-control mb-3 mt-3"
                placeholder="Search..."
                value={searchText}
                onChange={handleSearch}
              />
              {searchText && (
                <button className="btn btn-clear" onClick={clearSearch}>
                  <span>&times;</span> {/* This represents the close icon */}
                </button>
              )}
            </div>

            <div>
              <DataTable
                title="Auction List"
                columns={columns}
                data={filteredData}
              />
              {totalPages > 1 && (
                <Row>
                  <Col md={12} className="text-right">
                    <div className="pagination-controls">
                      <label>Rows per page: </label>
                      <select
                        id="itemsPerPage"
                        value={perPage}
                        onChange={(event) => changePerPage(Number(event.target.value))}
                      >
                        {pageSizes.map((option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>

                      <Button
                        onClick={previousPage}
                        disabled={page === 1}
                      >
                        <icons.ArrowLeft></icons.ArrowLeft>
                      </Button>
                      <span>
                        {" "}
                        {page} of {totalPages}{" "}
                      </span>
                      <Button
                        onClick={nextPage}
                        disabled={page >= totalPages}
                      >
                        <icons.ArrowRight></icons.ArrowRight>
                      </Button>
                    </div>
                  </Col>
                </Row>
              )}
            </div>
          </div>
        </div>
        <div className={data ? "footer" : "footer-content"}>
          <Footer />
        </div>
      </div>
    </>
  );
};
